import { useEffect } from "react";

export const useExistingRegistrationSync = ({
  existingUser,
  prefilledEmail,
  formData,
  setFormData,
  setIsExistingUser,
  conferenceDataLoadedRef,
  setSavedMembershipNumber,
  setSavedStudentIdCard,
  setSavedStudentIdCardName,
  setSavedStudentIdCardType,
}) => {
  useEffect(() => {
    if (existingUser && existingUser.email) {
      setFormData((prev) => {
        const shouldUpdate = !prev.email || prev.email === existingUser.email;

        if (!shouldUpdate) {
          return prev;
        }

        if (conferenceDataLoadedRef.current) {
          return prev;
        }

        return {
          ...prev,
          id: existingUser.id || prev.id || "",
          title: existingUser.title || prev.title || "",
          firstName: existingUser.firstName || prev.firstName || "",
          lastName: existingUser.lastName || prev.lastName || "",
          email: existingUser.email || prev.email || "",
          mobile: existingUser.phone || prev.mobile || "",
          gender: existingUser.gender || prev.gender || "",
          country: existingUser.country || prev.country || "",
          state: existingUser.state || prev.state || "",
          city: existingUser.city || prev.city || "",
          pincode: existingUser.zipCode || prev.pincode || "",
          address: existingUser.address || prev.address || "",
          affiliation: existingUser.affiliation || prev.affiliation || "",
          institution: existingUser.institution || prev.institution || "",
          fullNameCertificate: existingUser.getFullName
            ? existingUser.getFullName()
            : prev.fullNameCertificate ||
              `${existingUser.firstName || ""} ${
                existingUser.lastName || ""
              }`.trim(),
        };
      });
      setIsExistingUser(true);
    }
  }, [existingUser, conferenceDataLoadedRef, setFormData, setIsExistingUser]);

  useEffect(() => {
    if (prefilledEmail && !existingUser) {
      setFormData((prev) => ({
        ...prev,
        email: prefilledEmail,
      }));
      setIsExistingUser(false);
    }
  }, [prefilledEmail, existingUser, setFormData, setIsExistingUser]);

  useEffect(() => {
    if (formData.membershipNumber && formData.category === "ISCCM(Members)") {
      setSavedMembershipNumber(formData.membershipNumber);
    }
    if (
      formData.studentIdCard &&
      (formData.category === "Student" || formData.category === "student")
    ) {
      setSavedStudentIdCard(formData.studentIdCard);
      setSavedStudentIdCardName(formData.studentIdCardName);
      setSavedStudentIdCardType(formData.studentIdCardType);
    }
  }, []);
};
